var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"mobileStepHeader"}},[_c('subscription-steps-navigation',{attrs:{"is-mobile":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }